import React, { Component } from 'react';
import Radium from 'radium';

import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';


class AuthComponent extends Component {

    state = {}

    async handleLogin() {
        const { setAuthorizedUser, closeAuth } = this.props
        
        this.setState({loginError: false, usernameError: false, passwordError: false})

        let requestBody = new URLSearchParams()
        requestBody.append('username', this.state.username)
        requestBody.append('password', this.state.password)
        try {
            let resp = await fetch('/api/auth/login', {
                credentials: 'include',
                body: requestBody,
                method: 'POST'
            })
            let json = await resp.json()
            console.log(json)
            if (json.result) {
              setAuthorizedUser({
                  username: this.state.username, 
                  roles: json.roles, 
                  city: json.city, 
                  objectIds: json.objectIds
                })
              closeAuth()
              window.location.reload()
            } else {
              this.setState({loginError: true, usernameError: true, passwordError: true})
            }
        } catch (e) {
            console.error(e)
            this.setState({loginError: true, usernameError: true, passwordError: true})
        }
    }

    async handleLogout() {
        const {setAuthorizedUser} = this.props
        try {
            let resp = await fetch('/api/auth/logout', {credentials: 'include'})
            sessionStorage.clear()
            setAuthorizedUser(null)
            this.setState({
                username: undefined, 
                roles: undefined, 
                city: undefined, 
                objectIds: undefined
            })
            window.location.reload()
        } catch (e) {
            console.error(e)
        }
    }

    async handleAuth() {
        if (this.state.username === '' || this.state.username === null || this.state.username === undefined) {
            this.setState({usernameError: true})
            return
        }
        if (this.state.password === '' || this.state.password === null || this.state.password === undefined) {
            this.setState({passwordError: true})
            return
        }
        await this.handleLogin()
    }

    async componentWillMount() {
        const {setAuthorizedUser} = this.props
        let resp = await fetch('/api/auth/whoami', {
                credentials: 'include',
            })
            let json = await resp.json()
            console.log(json)
        if (json.result) {
            setAuthorizedUser({
                username: json.username, 
                roles: json.roles, 
                city: json.city, 
                objectIds: json.objectIds
            })
            this.setState(this.state)
        }
    }

    render () {

        const { isAuthOpened, closeAuth, authorizedUser, onSelectClick } = this.props

        return (
            <Dialog
              open={isAuthOpened}
              onClose={closeAuth}
              aria-labelledby="form-dialog-title"
            >
              <DialogTitle id="form-dialog-title">Авторизация</DialogTitle>
              {!authorizedUser ?
                  <DialogContent>
                    <DialogContentText>
                    {this.state.loginError || this.state.passwordError || this.state.usernameError ? 
                        <Typography color='red'>Неверное имя пользователя или пароль</Typography> : null
                    }
                    </DialogContentText>
                    <TextField
                      error={this.state.usernameError}
                      value={this.state.username}
                      onChange={(e) => this.setState({username: e.target.value, usernameError: false})}
                      autoFocus
                      margin="dense"
                      id="username"
                      label="Имя пользователя"
                      type="text"
                      fullWidth
                    />
                    <TextField
                      error={this.state.passwordError}
                      value={this.state.password}
                      onChange={(e) => this.setState({password: e.target.value, passwordError: false})}
                      margin="dense"
                      id="password"
                      label="Пароль"
                      type="password"
                      fullWidth
                    />
                  </DialogContent>
                : <DialogContent>
                    <DialogContentText>
                        Вы зашли под учетной записью <b>{authorizedUser.username}</b><br />  ({
                            authorizedUser.roles.map(r =>
                              {return {"admin": "администратор", "user": "пользователь", "viewer": "наблюдатель", "single_object_user": "с ограниченным числом объектов"}[r]}
                            ).join(', ')
                          })
                        {
                            authorizedUser.objectIds && authorizedUser.roles.includes('single_object_user') ?
                                <div><br />
                                {authorizedUser.objectIds.length > 1 ?
                                    'Список объектов, доступных для редактирования:' :
                                    'Для редактирования доступен только один объект:'
                                } {
                                    authorizedUser.objectIds.map((objectId) =>
                                      <span style={{"white-space": "nowrap"}}><a href='#' onClick={
                                        () => {
                                            onSelectClick(objectId);
                                            closeAuth();
                                        }}>
                                          №{objectId} (нажмите, чтобы перейти)</a></span>
                                    ).reduce((acc, x) =>
                                        acc === null ? [x] : [acc, ', ', x], null
                                    )}
                                </div> : null
                        }
                        {authorizedUser && authorizedUser.roles.includes('admin') ?
                          <div><br />
                          <a href='/api/logs' target='_blank'>Логи действий пользователей</a>
                          </div>
                          : null
                        }

                    </DialogContentText>
                  </DialogContent>
                }
                {!authorizedUser ? 
                    <DialogActions>
                    <Button onClick={() => this.handleAuth()} color="primary">
                      Войти
                    </Button>
                  </DialogActions>
                    : <DialogActions>
                    <Button onClick={() => this.handleLogout()} color="primary">
                      Выйти
                    </Button>
                  </DialogActions>
              }
                </Dialog>
        )
    }
}

const styles = (theme => ({
      
  }));

export default Radium(withStyles(styles)(AuthComponent))


// WEBPACK FOOTER //
// ./src/AuthComponent.js